// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timer-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  transform: translateX(30px);
  /* cursor: pointer; */
}

.timer-wrapper svg,
.timer-wrapper div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px !important;
  height: 40px !important;
}

.timer-wrapper svg > path {
  width: 40px !important;
  height: 40px !important;
  offset: 10%;
}

.timer {
  font-family: "Montserrat", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.text {
  color: #aaa;
}

.value {
  font-size: 1.25rem;
}

.edit-text-modal {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 99;
  background-color: rgba(55, 58, 71, 0.9);
}
.dialog-content {
  width: 50%;
  max-width: 560px;
  min-width: 290px;
  text-align: center;
  /* opacity: 0; */
  transition: height 0.3s ease;
  font-size: .9rem;
  box-sizing: content-box;
}
.dialog-wrap {
  z-index: 3;
  padding: 40px;
  perspective: 800px;
  transition: transform 0.5s;
  background-color: #fff;
}
.dialog-wrap h3 {
  margin: 0;
  font-weight: 400;
  font-size: 1.4rem;
  padding: 0 0 20px;
  color: #1b3a4d;
}
.dialog-wrap p {
  margin: 0;
  font-weight: 300;
  font-size: .9rem;
  text-transform: none;
  padding: 0 0 1em;
  color: #bfbfbf;
}
.editional-section-wrapper::before {
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  border-top: 2px solid #e42029;
  border-left: 2px solid #e42029;
}
.editional-section-wrapper::after {
  content: "";
  display: block;
  width: 16px;
  height: 16px;
  margin-left: auto;
  border-right: 2px solid #e42029;
  border-bottom: 2px solid #e42029;
}
.editional-section {
  color: #e42029 !important;
}
.mistape_dialog_block {
  margin-top: 20px;
}
.mistape_action {
  display: inline-block;
  cursor: pointer;
  padding: 11px 25px;
  margin: 0 5px;
  font-weight: 600;
  border: none;
  color: #fff;
  background-color: #e42029;
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
  text-transform: uppercase;
  font-size: .9rem;
  min-width: 150px;
}

.wrap {
  background: linear-gradient(118.88deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);
  -webkit-backdrop-filter: blur(34px);
          backdrop-filter: blur(34px);
  border-radius: 25px;
  border: 3px solid #ffffff;
}

@media screen and (max-width: 450px) {
  .rek-modal__wrapper {
    width: 95%;
  }
  .timer-wrapper {
    transform: translateX(0px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gGAAgG;EAChG,mCAA2B;UAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".timer-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  transform: translateX(30px);\n  /* cursor: pointer; */\n}\n\n.timer-wrapper svg,\n.timer-wrapper div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px !important;\n  height: 40px !important;\n}\n\n.timer-wrapper svg > path {\n  width: 40px !important;\n  height: 40px !important;\n  offset: 10%;\n}\n\n.timer {\n  font-family: \"Montserrat\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.text {\n  color: #aaa;\n}\n\n.value {\n  font-size: 1.25rem;\n}\n\n.edit-text-modal {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  z-index: 99;\n  background-color: rgba(55, 58, 71, 0.9);\n}\n.dialog-content {\n  width: 50%;\n  max-width: 560px;\n  min-width: 290px;\n  text-align: center;\n  /* opacity: 0; */\n  transition: height 0.3s ease;\n  font-size: .9rem;\n  box-sizing: content-box;\n}\n.dialog-wrap {\n  z-index: 3;\n  padding: 40px;\n  perspective: 800px;\n  transition: transform 0.5s;\n  background-color: #fff;\n}\n.dialog-wrap h3 {\n  margin: 0;\n  font-weight: 400;\n  font-size: 1.4rem;\n  padding: 0 0 20px;\n  color: #1b3a4d;\n}\n.dialog-wrap p {\n  margin: 0;\n  font-weight: 300;\n  font-size: .9rem;\n  text-transform: none;\n  padding: 0 0 1em;\n  color: #bfbfbf;\n}\n.editional-section-wrapper::before {\n  content: \"\";\n  display: block;\n  width: 16px;\n  height: 16px;\n  border-top: 2px solid #e42029;\n  border-left: 2px solid #e42029;\n}\n.editional-section-wrapper::after {\n  content: \"\";\n  display: block;\n  width: 16px;\n  height: 16px;\n  margin-left: auto;\n  border-right: 2px solid #e42029;\n  border-bottom: 2px solid #e42029;\n}\n.editional-section {\n  color: #e42029 !important;\n}\n.mistape_dialog_block {\n  margin-top: 20px;\n}\n.mistape_action {\n  display: inline-block;\n  cursor: pointer;\n  padding: 11px 25px;\n  margin: 0 5px;\n  font-weight: 600;\n  border: none;\n  color: #fff;\n  background-color: #e42029;\n  text-decoration: none;\n  user-select: none;\n  text-transform: uppercase;\n  font-size: .9rem;\n  min-width: 150px;\n}\n\n.wrap {\n  background: linear-gradient(118.88deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%);\n  backdrop-filter: blur(34px);\n  border-radius: 25px;\n  border: 3px solid #ffffff;\n}\n\n@media screen and (max-width: 450px) {\n  .rek-modal__wrapper {\n    width: 95%;\n  }\n  .timer-wrapper {\n    transform: translateX(0px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
